module.exports = __webpack_public_path__ + "static/yebra-a347d62b83aa09847e83bf8f326989f7.jpg";